// itemsData.js - Kitchen and Tableware Items
// These are PLACEHOLDER items - replace with your actual kitchen items!

export const itemsData = [
  {
    id: 1,
    name: 'Skeppshult Casserole 3L',
    koreanName: '스켑슐트 캐서롤 3L',
    image: '/items-images/Skeppshult-casserole-3l-glass-lid-and-brass-grip.jpg',
    category: 'cookware',
    tags: ['iron pot', 'casserole', 'Skeppshult'],
    link: 'https://global.skeppshult.com/en/nutrient-cookware/62-casserole-3l-glass-lid-and-brass-grip.html' // Add your product link here (e.g., 'https://example.com/product')
  },
  {
    id: 2,
    name: 'Skeppshult Satue Pan 25cm',
    koreanName: '스켑슐트 소테팬 25cm',
    image: '/items-images/Skeppshult satue pan 25cm.jpg',
    category: 'cookware',
    tags: ['Iron Deep Pan', 'Satue Pan', 'Skeppshult'],
    link: 'https://global.skeppshult.com/en/professional/48-saute-pan-25-cm-stainlesssteel.html' // Add your product link here (e.g., 'https://example.com/product')
  },
  {
    id: 3,
    name: 'Staub Round Cocotte 18cm Black',
    koreanName: '스타우브 라운드 코코트 18cm 블랙',
    image: '/items-images/Staub Round Cocotte 18cm Black.jpg',
    category: 'cookware',
    tags: ['Iron Pot', 'Cocotte', 'Staub'],
    link: 'https://amzn.to/3KznZWW'
  },
  {
    id: 4,
    name: 'Tefal Ingenio Emotion 4 Piece Frypan Set',
    koreanName: '테팔 인제니오 이모션 4피스 프라이팬 세트',
    image: '/items-images/Tefal Ingenio Emotion Induction Non-Stick Stainless Steel 4 Piece Frypan Set.jpg',
    category: 'cookware',
    tags: ['Frying Pan', 'Tefal'],
    link: 'https://amzn.to/3J1tcpW'
  },
  {
    id: 5,
    name: 'Zwilling Four Star 6/Set',
    koreanName: '즈윌링 포스타 6개 세트',
    image: '/items-images/Zwilling Four Star 6 Set.jpg',
    category: 'cooking utensils & tools',
    tags: ['Knife', 'Zwilling'],
    link: 'https://m.zwilling.kr/product/%ED%81%B4%EB%A6%AC%EC%96%B4%EB%9F%B0%EC%8A%A4-%EC%84%B8%EC%9D%BC-%ED%8F%AC%EC%8A%A4%ED%83%80-6p-%EB%B8%94%EB%A1%9D-%EC%84%B8%ED%8A%B8/618/'
  },
  {
    id: 6,
    name: 'Victorinox Cutting Board Kitchen Series',
    koreanName: '빅토리녹스 커팅보드 키친 시리즈',
    image: '/items-images/Victorinox Cutting Board Kitchen Series.jpg',
    category: 'cooking utensils & tools',
    tags: ['cutting board', 'Victorinox'],
    link: 'https://amzn.to/4he0wGJ'
  },
  {
    id: 7,
    name: 'Asahi Cookin Cut Rubber Cutting Board, Large',
    koreanName: '아사히 고무 도마, 라지',    image: '/items-images/Asahi Cookin Cut Rubber Cutting Board.jpg',
    category: 'cooking utensils & tools',
    tags: ['cutting board', 'Asahi'],
    link: 'https://amzn.to/46JbhNV'
  },
  {
    id: 8,
    name: 'Stagg EKG Electric Kettle',
    koreanName: 'Stagg EKG 전기 주전자',
    image: '/items-images/Stagg EKG Electric Kettle.jpg',
    category: 'appliances',
    tags: ['electric kettle', 'Stagg', 'Fellow Products'],
    link: 'https://amzn.to/3IY2HBB'
  },
  {
    id: 9,
    name: 'Kinto Cast Iced Tea Glass',
    koreanName: '킨토 캐스트 아이스티 글라스',
    image: '/items-images/Kinto Cast Iced Tea Glass.jpg',
    category: 'drinkware',
    tags: ['glass tumbler', 'Kinto', 'drinkware'],
    link: 'https://milligram.com/products/kinto-cast-iced-tea-glass'
  },
  {
    id: 10,
    name: 'Huskee Original Range 8oz 4-Pack Natural & Black',
    koreanName: '허스키 오리지널 레인지 8oz 4-팩 내추럴 & 블랙',
    image: '/items-images/HuskeeOriginal Range 8oz 4-Pack Natural.jpg',
    category: 'drinkware',
    tags: ['tumbler', 'Huskee', 'drinkware'],
    link: 'https://huskee.co/8oz-4-pack/'
  },
  {
    id: 11,
    name: 'Mino Pottery Mino Ware Curio 210 Deep Plate',
    koreanName: '미노 포토리 미노 웨어 커리 210 딥 플레이트',
    image: '/items-images/Mino Pottery Mino Ware Curio 210 Deep Plate.jpg',
    category: 'tableware',
    tags: ['plate', 'Mino Pottery'],
    link: 'https://amzn.to/3KHz1t4'
  },
  {
    id: 12,
    name: 'Aderia Retro Glass with Stand with Pear 11.2 fl oz',
    koreanName: '아데리아 리트로 글라스 스탠드 피어 11.2 fl oz',
    image: '/items-images/Aderia Retro Glass with Stand with Pear 11.2 fl oz.jpg',
    category: 'drinkware',
    tags: ['glass tumbler', 'Aderia', 'drinkware'],
    link: 'https://amzn.to/46IUNp2'
  },
  {
    id: 13,
    name: 'Minoru Pottery Mino Ware Curio 195 Plate',
    koreanName: '미노 포토리 미노 웨어 커리 195 플레이트',
    image: '/items-images/Minoru Pottery Mino Ware Curio 195 Plate.jpg',
    category: 'tableware',
    tags: ['plate', 'Minoru Pottery'],
    link: 'https://amzn.to/3KHz1t4'
  },
  {
    id: 14,
    name: 'Muji Stainless Steel Cutting Board Stand - Double',
    koreanName: '무지 스테인리스 스틸 커팅보드 스탠드 - 더블',
    image: '/items-images/Muji Stainless Steel Cutting Board Stand - Double.jpg',
    category: 'cooking utensils & tools',
    tags: ['cutting board stand', 'Muji'],
    link: 'https://muji.com.au/products/stainless-steel-cutting-board-stand-double?srsltid=AfmBOopgzpThttfKVudeaYcbKSakwH12pd_Ru0C6mtZrbpExaYioeWzN&variant=42484880802011'
  },
  {
    id: 15,
    name: 'Essteele Per Sempre Clad Stainless Steel Saucepan 14cm/0.9L',
    koreanName: '엘스티일 퍼 세미프레 클래드 스테인리스 스튜 팬 14cm/0.9L',
    image: '/items-images/Essteele Per Sempre Clad Stainless Steel Saucepan.jpg',
    category: 'cookware',
    tags: ['saucepan', 'Essteele'],
    link: 'https://amzn.to/4q0IsnB'
  },
  {
    id: 16,
    name: 'Essteele Per Vita Copper Base Stainless Steel Sautéuse 28cm/5.2L',
    koreanName: '엘스티일 퍼 비타 커피 베이스 스테인리스 스튜 팬 28cm/5.2L',
    image: '/items-images/Essteele Per Vita Copper Base Stainless Steel Sauteuse 28cm.jpg',
    category: 'cookware',
    tags: ['sautéuse', 'Essteele'],
    link: 'https://amzn.to/46Jl46H'
  },
  {
    id: 17,
    name: 'Muji Stainless Steel Measuring Cup - 200ml',
    koreanName: '무지 스테인리스 스틸 미터링 컵 - 200ml',
    image: '/items-images/Muji Stainless Steel Measuring Cup - 200ml.jpg',
    category: 'cooking utensils & tools',
    tags: ['measuring cup', 'Muji'],
    link: 'https://shop.app/products/8351077400795?fromShop=true'
  },
  {
    id: 18,
    name: 'Rust Deluxe Kitchen Sink Suction Holder for Sponges',
    koreanName: '러스 델루이드 키친 싱크 수채 홀더 스펀지',
    image: '/items-images/Rust Deluxe Kitchen Sink Suction Holder for Sponges.jpg',
    category: 'cleaning tools',
    tags: ['sponge holder', 'Rust'],
    link: 'https://amzn.to/48WuSeN'
  },
  {
    id: 19,
    name: 'OXO Good Grips Julienne Prep Peeler',
    koreanName: '옥소 고드립스 줄리엔 프리페어 페어러',
    image: '/items-images/OXO Good Grips Julienne Prep Peeler.jpg',
    category: 'cooking utensils & tools',
    tags: ['peeler', 'OXO'],
    link: 'https://amzn.to/48hUumf'
  },
  {
    id: 20,
    name: 'Muji Stainless Steel Long Measuring Spoon 15ml, 5ml',
    koreanName: '무지 스테인리스 스틸 롱 미터링 스푼 15ml, 5ml',
    image: '/items-images/Muji Stainless Steel Long Measuring Spoon 15ml.jpg',
    category: 'cooking utensils & tools',
    tags: ['measuring spoon', 'Muji'],
    link: 'https://shop.app/products/7910333153499?fromShop=true'
  },
  {
    id: 21,
    name: 'MUJI Silicone Cooking Spoon Small 25cm',
    koreanName: '무지 실리콘 쿠킹 스푼 스몰 25cm',
    image: '/items-images/MUJI Silicone Cooking Spoon Small 25cm.jpg',
    category: 'cooking utensils & tools',
    tags: ['cooking spoon', 'Muji'],
    link: 'https://shop.app/products/7910333153499?fromShop=truehttps://shop.app/products/6686448877623'
  },
  {
    id: 22,
    name: '3 Set Muji Stainless Steel Mixing Bowls',
    koreanName: '무지 스테인리스 스틸 믹싱 볼 3세트',
    image: '/items-images/3SET MUJI STAINLESS STEEL MIXING BOWLS.jpg',
    category: 'cooking utensils & tools',
    tags: ['mixing bowls', 'Muji'],
    link: 'https://shop.app/products/7813807603931?fromShop=true'
  },
  {
    id: 23,
    name: 'Muji Stainless Steel Strainer',
    koreanName: '무지 스테인리스 스틸 스트레이너',
    image: '/items-images/Muji Stainless Steel Strainer.jpg',
    category: 'cooking utensils & tools',
    tags: ['strainer', 'Muji'],
    link: 'https://shop.app/products/8847591473371?fromShop=true&variantId=46763657887963'
  },
  {
    id: 24,
    name: 'Tawashi Vegetable Brushes Natural Coconut Fiber',
    koreanName: '아사히 고무 채칼, 나카 브라운',
    image: '/items-images/Tawashi Vegetable Brushes Natural Coconut Fiber.jpg',
    category: 'cleaning tools',
    tags: ['vegetable brush', 'Tawashi'],
    link: 'https://www.amazon.com.au/Tawashi-Vegetable-Brushes-Japanese-Household/dp/B089ZP34GN/ref=asc_df_B089ZP34GN?mcid=27eb947121293a9e9212a382a33ded2f&tag=googleshopdsk-22&linkCode=df0&hvadid=712276151905&hvpos=&hvnetw=g&hvrand=7694619912459113294&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=9071729&hvtargid=pla-944913513271&psc=1&gad_source=1'
  },
  {
    id: 25,
    name: 'Urethane Foam Sponge With Handle',
    koreanName: '우레탄 폼 스펀지 핸들 커버',
    image: '/items-images/Urethane Foam Sponge With Handle.jpg',
    category: 'cleaning tools',
    tags: ['sponge', 'Urethane', 'muji'],
    link: 'https://amzn.to/48mUuBw'
  },
  {
    id: 26,
    name: 'Nespresso Vertuo Pop Solo Coconut White',
    koreanName: '네스프레소 버투포프 솔로 코코넛 화이트',
    image: '/items-images/Nespresso Vertuo Pop Solo Coconut White.jpg',
    category: 'appliances',
    tags: ['coffee maker', 'Nespresso'],
    link: 'https://amzn.to/3J5aWvP'
  },
  {
    id: 27,
    name: 'Bodum Coffee maker with permanent filter',
    koreanName: '보둠 전기 커피 그라인더',
    image: '/items-images/Coffee maker with permanent filter.jpg',
    category: 'appliances',
    tags: ['coffee maker', 'permanent filter', 'bodum'],
    link: 'https://amzn.to/4nGU4dQ'
  },
  {
    id: 28,
    name: 'Bodum Electric Coffee Grinder',
    koreanName: '보둠 전기 커피 그라인더',
    image: '/items-images/Bodum Electric Coffee Grinder.jpg',
    category: 'appliances',
    tags: ['coffee grinder', 'bodum'],
    link: 'https://amzn.to/4nGU4dQ'
  },
  {
    id: 29,
    name: 'Dusen Dusen Everybody Timer',
    koreanName: '두센두센 에브리팅 타이머',
    image: '/items-images/Dusen Dusen Everybody Timer.png',
    category: 'accessories',
    tags: ['timer', 'Dusen Dusen'],
    link: 'https://amzn.to/4h1NBYx'
  },
  {
    id: 30,
    name: 'Selena Liu Serving Friends Pot Holders',
    koreanName: '셀레나 리우 서빙 프렌즈 팟 홀더',
    image: '/items-images/Selena Liu Serving Friends Pot Holders.jpg',
    category: 'accessories',
    tags: ['pot holder', 'Selena Liu'],
    link: 'https://www.areaware.com/products/serving-friends-pot-holders?srsltid=AfmBOopRfwycSPywHuV_es6ZApSF5H7AdG5ROxBiIAECG_z8XG0wcSXl&variant=46140306030815'
  },
  {
    id: 31,
    name: 'Ninja Detect Kitchen System Power Blender + Processor Pro',
    koreanName: '네이지 디텍 키친 시스템 파워 블렌더 + 프로세서 프로',
    image: '/items-images/Ninja Detect Kitchen System Power Blender.jpg',
    category: 'appliances',
    tags: ['placeholder'],
    link: 'https://amzn.to/4q1yPoB'
  },
  {
    id: 32,
    name: 'Breville the Toast and Melt 2-Slice Sandwich Press',
    koreanName: '브레벨 토스트 앤 멜트 2-슬라이스 샌드위치 프레스',
    image: '/items-images/Breville the Toast and Melt 2-Slice Sandwich Press.jpg',
    category: 'cookware',
    tags: ['sandwich press', 'Breville'],
    link: 'https://amzn.to/48QBWK0'
  },
  {
    id: 33,
    name: 'Scrub Daddy - Flex Texture Scrubber',
    koreanName: '스크럽 데디 플렉스 텍스처 스크러버',
    image: '/items-images/The Original Scrub Daddy - Multipurpose Cleaning Sponge - Soft in Warm Water, Firm in Cold Water for Tough Cleaning.jpg',
    category: 'cleaning tools',
    tags: ['sponge', 'Scrub Daddy'],
    link: 'https://amzn.to/3KEVoQ0'
  },
  {
    id: 34,
    name: 'Sponge Daddy - Dual-Sided Sponge & Scrubber',
    koreanName: '스크럽 데디 더블 사이드 스펀지 & 스크러버',
    image: '/items-images/Sponge Daddy - Multipurpose Cleaning Scrubber and Sponge - One Side for Scrubbing, the Other for Mopping Up.jpg',
    category: 'cleaning tools',
    tags: ['sponge', 'Scrub Daddy'],
    link: 'https://amzn.to/3WvNN8Q'
  },
  {
    id: 35,
    name: 'Muji Stainless Steel Tray',
    koreanName: '무지 스테인리스 스틸 트레이',
    image: '/items-images/Muji Stainless Steel Tray.jpg',
    category: 'cooking utensils & tools',
    tags: ['tray', 'Muji'],
    link: 'https://muji.com.au/products/stainless-steel-vat-s?variant=42240810877147'
  },
  {
    id: 36,
    name: 'Muji Stainless Steel Dish Rack Basket',
    koreanName: '무지 스테인리스 스틸 디시 랙 바스켓',
    image: '/items-images/Muji Stainless Steel Dish Rack Basket.jpg',
    category: 'cleaning tools',
    tags: ['dish rack', 'Muji'],
    link: 'https://muji.com.au/'
  },
  {
    id: 37,
    name: 'Cuchen Electric Multi Pressure Korean Rice Cooker',
    koreanName: '아사히 고무 도마, 라지 크기',
    image: '/items-images/Cuchen Electric Multi Pressure Korean Rice Cooker.jpg',
    category: 'appliances',
    tags: ['rice cooker', 'Cuchen'],
    link: 'https://amzn.to/4ohiv1D'
  },
  {
    id: 38,
    name: 'Udon Bowl 16 cm Oatmeal Glaze',
    koreanName: '우동 보울 16 cm 오트밀 글레이즈',
    image: '/items-images/Udon Bowl 16 cm Oatmeal Glaze.jpg',
    category: 'tableware',
    tags: ['Bowl'],
    link: 'https://mij.com.au/products/udon-bowl-850-ml-oatmeal-glaze-16-cm?_pos=1&_sid=73d067800&_ss=r'
  },
  {
    id: 39,
    name: 'Side Plate 21cm Ivory Rinka Glaze',
    koreanName: '사이드 플레이트 21cm 아이보리 린카 글레이즈',
    image: '/items-images/Plate 21cm Ivory Rinka Glaze.jpg',
    category: 'tableware',
    tags: ['plate'],
    link: 'https://mij.com.au/products/side-plate-21-cm-ivory-rinka-glaze?_pos=1&_sid=b0c2b3c20&_ss=r'
  },
  {
    id: 40,
    name: 'Muji Stainless Steel Grater',
    koreanName: '무지 스테인리스 스틸 그레이터',
    image: '/items-images/Muji Stainless Steel Grater.jpg',
    category: 'cooking utensils & tools',
    tags: ['grater', 'Muji'],
    link: 'https://muji.com.au/products/stainless-steel-grater?_pos=11&_sid=9c3da6caa&_ss=r&variant=42240809992411'
  },
  {
    id: 41,
    name: 'TJ POP End Grain Acacia Wood Chopping Board',
    koreanName: '엔드 그레인 아카시아 우드 도마',
    image: '/items-images/End Grain Acacia Wood Chopping Board.jpg',
    category: 'cooking utensils & tools',
    tags: ['cutting wood board oil', 'End Grain Acacia Wood'],
    link: 'https://amzn.to/4q2yqCk'
  },
  {
    id: 42,
    name: 'Chopping Board Oil 200ml Food Grade Mineral Oil',
    koreanName: '나무 도마 오일 200ml 식품용 미네랄 오일',
    image: '/items-images/Chopping Board Oil 200ml Food Grade Mineral Oil Made in Australia.jpg',
    category: 'cleaning tools',
    tags: ['chopping board oil'],
    link: 'https://amzn.to/3KzCmdR'
  },
  {
    id: 43,
    name: '8.5oz Espresso Cup with Handle & Measuring Cup',
    koreanName: '8.5oz 에스프레소 컵 핸들 & 미터링 컵',
    image: '/items-images/Espresso Cup with Handle,Measuring Cup 8.5oz.jpg',
    category: 'cooking utensils & tools',
    tags: ['espresso cup', 'Measuring Cup'],
    link: 'https://amzn.to/42Tj6OP'
  },
  {
    id: 44,
    name: 'Aderia Retro Glass with Stand with Flower 11.2 fl oz',
    koreanName: '아데리아 레트로 글라스 스탠드 피어 11.2 fl oz',
    image: '/items-images/Aderia Retro Glass with Stand with Flower 11.2 fl oz.jpg',
    category: 'drinkware',
    tags: ['glass tumbler', 'Aderia'],
    link: 'https://amzn.to/42Tj6OP'
  },
  {
    id: 45,
    name: 'Minoru Pottery Mino Ware CHOTTO 95 Cloud Plates, Light Blue, Set of 2',  
    koreanName: '미노 포토리 미노 웨어 커리 95 클라우드 플레이트, 라이트 블루, 2개 세트',
    image: '/items-images/Minoru Pottery Mino Ware CHOTTO 95 Cloud Plates, Light Blue, Set of 2.jpg',
    category: 'tableware',
    tags: ['sauce plate', 'Minoru Pottery'],
    link: 'https://amzn.to/4oatFVC'
  },
  {
    id: 46,
    name: '12 Inch Stainless Steel Baking Sheet with Cooling Rack',
    koreanName: '12인치 스테인리스 스틸 베이킹 시트 쿨링 랙',
    image: '/items-images/12 Inch Stainless Steel Baking Sheet with Cooling and Roasting Rack.jpg',
    category: 'baking',
    tags: ['baking sheet', 'roasting sheet', 'Stainless Steel'],
    link: 'https://amzn.to/4mRYv4j'
  },
  {
    id: 47,
    name: 'Avanti Perforated Strainer with Insulated Handle, 20cm',
    koreanName: '아반티 퍼포레이티드 채반 인슐레이티드 핸들, 20cm',
    image: '/items-images/Avanti Perforated Strainer with Insulated Handle, 20cm.jpg',
    category: 'cooking utensils & tools',
    tags: ['strainer', 'Avanti'],
    link: 'https://amzn.to/4oaWLUL'
  },
  {
    id: 48,
    name: 'Kilner Square Clip Top Jar, 1L',
    koreanName: '킬너 스퀘어 클립 유리병 , 라지 1L',
    image: '/items-images/Kilner Square Clip Top Jar, 1L.jpg',
    category: 'storage',
    tags: ['jar', 'Kilner'],
    link: 'https://amzn.to/4nPVG5m'
  },
  {
    id: 49,
    name: 'Kilner Square Clip Top Jar, 0.5L',
    koreanName: '킬너 스퀘어 클립 유리병, 스몰 0.5L',
    image: '/items-images/Kilner Square Clip Top Jar, 0.5L.jpg',
    category: 'storage',
    tags: ['jar', 'Kilner'],
    link: 'https://amzn.to/46HvqDZ'
  },
  {
    id: 50,
    name: 'Kilner 222.467 Genuine Preserve Jar 6-Piece Set, 250ml', 
    koreanName: '킬너 222.467 유리병 6-팩 세트, 250ml',
    image: '/items-images/Kilner 222.467 Genuine Preserve Jar 6-Piece Set, 250 ml.jpg',
    category: 'storage',
    tags: ['jar', 'Kilner'],
    link: 'https://amzn.to/4nT66Rm'
  },
  {
    id: 51,
    name: 'Kilner Wide Mouth Preserve Jar Set 6-Pieces, 500ml', 
    koreanName: '킬너 와이드 유리병 6팩 세트, 500ml',
    image: '/items-images/Kilner Wide Mouth Preserve Jar Set 6-Pieces, 500 ml Capacity.jpg',
    category: 'storage',
    tags: ['jar', 'Kilner'],
    link: 'https://amzn.to/3KJAKOw'
  },
  {
    id: 52,
    name: 'Kilner Wide Mouth Preserve Jar Set 6-Pieces, 350ml',
    koreanName: '킬너 와이드 유리병 6팩 세트, 350ml',
    image: '/items-images/Kilner Wide Mouth Preserve Jar Set 6-Pieces, 350 ml Capacity.jpg',
    category: 'storage',
    tags: ['jar', 'Kilner'],
    link: 'https://amzn.to/4nO7MMi'
  },
  {
    id: 53,
    name: '17oz Glass Olive Oil Dispenser Bottle Set, 500ml', 
    koreanName: '17oz 글라스 올리브 오일 디스펜서 병 세트, 500ml 클리어 오일 & 비닐',
    image: '/items-images/17oz Glass Olive Oil Dispenser Bottle Set, 500ml Clear Oil & Vinegar.jpg',
    category: 'cooking utensils & tools',
    tags: ['dispenser', 'glass'],
    link: 'https://amzn.to/48QG64A'
  },
  {
    id: 54,
    name: 'Bakemaster Non-Stick Loose Base Round Deep Cake Pan',
    koreanName: '바케마스터 논스틱 로스 베이스 라운드 딥 케이크 팬',
    image: '/items-images/Bakemaster Non-Stick Loose Base Round Deep Cake Pan, Grey, 40045 8 cm_18 cm_ 18 cm.jpg',
    category: 'baking',
    tags: ['cake pan'],
    link: 'https://amzn.to/4q74y8c'
  },
  {
    id: 55,
    name: 'Oxo Good Grips Spatula, Medium',
    koreanName: '옥스 굿 그립스 스파쿠라, 미디엄',
    image: '/items-images/Oxo Good Grips Spatula, Medium.jpg',
    category: 'baking',
    tags: ['spatula', 'Oxo'],
    link: 'https://amzn.to/46Jq1MP'
  },
  {
    id: 56,
    name: 'Orblue Lemon Zester & Cheese Grater',  
    koreanName: '오블루 레몬 제스터 & 치즈 그레이터',
    image: '/items-images/Orblue Lemon Zester & Cheese Grater.jpg',
    category: 'baking',
    tags: ['zester', 'grater', 'Orblue'],
    link: 'https://amzn.to/3IVCFz5'
  },
  {
    id: 57,
    name: 'Avanti Citrus Rubberwood Reamer',
    koreanName: '아반티 시트러스 러버우드 리머',
    image: '/items-images/Avanti Citrus Rubberwood Reamer.jpg',
    category: 'baking',
    tags: ['reamer', 'Avanti'],
    link: 'https://amzn.to/3KHBTWT'
  },
  {
    id: 58,
    name: 'Silicone Assist Handle, pot holders',
    koreanName: '실리콘 어시스트 핸들, 팟 홀더',
    image: '/items-images/Silicone Assist Handle, pot holders.jpg',
    category: 'accessories',
    tags: ['pot holder', 'Silicone'],
    link: 'https://amzn.to/3J0d7kd'
  },
  {
    id: 59,
    name: 'Airrmade Ceramic Butter Mug',
    koreanName: '에어림드 세라믹 버터 머그컵',
    image: '/items-images/airrmade ceramic butter mug.jpg',
    category: 'drinkware',
    tags: ['mug', 'thumbler', 'Airrmade'],
    link: 'https://www.airrmade.com/'
  },
  {
    id: 60,
    name: 'Airrmade Ceramic Brownie Mug',
    koreanName: '에어림드 세라믹 브라운 머그컵',
    image: '/items-images/airrmade ceramic brownie mug.jpg',
    category: 'drinkware',
    tags: ['mug', 'thumbler', 'Airrmade'],
    link: 'https://www.airrmade.com/'
  },
  {
    id: 61,
    name: 'Glasslock Handy Tempered Glass Rectangle (Kimchi Storage)',
    koreanName: '글래스락 핸디 템페럴 글라스 사각형 김치 유리 컨테이너',
    image: '/items-images/Glasslock Handy Tempered Glass Rectangle (Kimchi Storage).jpg',
    category: 'storage',
    tags: ['glass lock', 'Glasslock','kimchi storage', 'storage'],
    link: 'https://amzn.to/4gXsx5i'
  },
  {
    id: 62,
    name: 'IKEA 365+ Food container with lid, rectangular stainless steel 1L',
    koreanName: '아이케 365+ 푸드 컨테이너 유리 컨테이너, 라지 1L',
    image: '/items-images/IKEA-365-Food container-1.0L.jpg',
    category: 'storage',
    tags: ['stainless steelcontainer', 'IKEA', 'storage'],
    link: 'https://www.ikea.com/au/en/p/ikea-365-food-container-with-lid-rectangular-stainless-steel-plastic-s89437507/?utm_source=google&utm_medium=organic-shopping&utm_campaign=shopping_feed&utm_content=free_google_shopping_clicks_Cooking'
  },
  {
    id: 63,
    name: 'Glasslock Classic Tempered Glass Set of 10',
    koreanName: '글래스락 클래식 글라스 통 세트 10개',
    image: '/items-images/GLASSLOCK Classic Tempered Glass Set of 10 Different Sized Containers.jpg',
    category: 'storage',
    tags: ['glass lock', 'Glasslock', 'storage'],
    link: 'https://www.glasslock.com.au/product-page/glasslock-classic-tempered-glass-set-of-10-different-sized-containers'
  },
  {
    id: 64,
    name: 'salt&pepper Ogin Glass Footed Cake Plate',
    koreanName: 'salt&pepper 글라스 푸드 플레이트',
    image: '/items-images/salt&pepper Ogin Glass Footed Cake Plate.jpg.jpg',
    category: 'tableware',
    tags: ['cake plate', 'salt&pepper'],
    link: 'https://amzn.to/4q2ANFe'
  },
  {
    id: 65,
    name: 'Muji Plain Weave Linen Oven Mitt',
    koreanName: '무지 플레인 위브 리넨 오븐 글러브',
    image: '/items-images/Muji Plain Weave Linen Oven Mitt.jpg',
    category: 'accessories',
    tags: ['oven mitt', 'Muji'],
    link: 'https://muji.com.au/products/everyday-tableware-plate-medium-mdo43a3a?_pos=1&_sid=89c6f55ba&_ss=r&variant=46689039974619'
  },
  {
    id: 66,
    name: 'Muji Everyday Tableware Bowl - Small',
    koreanName: '무지 플레인 위브 리넨 오븐 글러브',
    image: '/items-images/Muji Everyday Tableware Bowl - Small.jpg',
    category: 'tableware',
    tags: ['bowl', 'Muji'],
    link: 'https://muji.com.au/products/everyday-tableware-bowl-small-mdo66a3a?variant=46765495976155'
  },
  {
    id: 67,
    name: 'Everyday Tableware Oval Plate - Small',
    koreanName: '무지 플레인 위브 리넨 오븐 글러브',
    image: '/items-images/Everyday Tableware Oval Plate - Small.jpg',
    category: 'tableware',
    tags: ['oval plate', 'Muji'],
    link: 'https://muji.com.au/products/everyday-tableware-oval-plate-small-mdo20a3a?variant=46689002553563'
  },
  {
    id: 68,
    name: 'Muji Everyday Tableware Plate - Medium',
    koreanName: '무지 플레인 위브 리넨 오븐 글러브',
    image: '/items-images/Muji Everyday Tableware Plate - Medium.jpg',
    category: 'tableware',
    tags: ['plate', 'Muji'],
    link: 'https://muji.com.au/products/everyday-tableware-plate-medium-mdo43a3a?_pos=1&_sid=89c6f55ba&_ss=r&variant=46689039974619'
  },
  {
    id: 69,
    name: 'Muji Everyday Tableware Oval Bowl',
    koreanName: '무지 플레인 위브 리넨 오븐 글러브',
    image: '/items-images/Muji Everyday Tableware Oval Bowl.jpg',
    category: 'tableware',
    tags: ['oval oval', 'Muji'],
    link: 'https://muji.com.au/products/everyday-tableware-oval-bowl-mdo19a3a?_pos=1&_sid=7b429c622&_ss=r&variant=46680607097051'
  },
  {
    id: 70,
    name: 'Muji PET Foaming Refill Bottle - Clear (400ml)',
    koreanName: '무지 PET 폼링 리필 병 - 클리어 (400ml)',
    image: '/items-images/Muji PET Foaming Refill Bottle - Clear (400ml).jpg',
    category: 'cleaning tools',
    tags: ['foaming refill bottle', 'Muji'],
    link: 'https://muji.com.au/products/pet-foaming-refill-bottle-clear-400ml?_pos=1&_sid=4f64dfc2d&_ss=r&variant=42330880704731'
  },
  {
    id: 71,
    name: 'Muji Stainless Steel Skimmer',
    koreanName: '무지 스테인리스 스틸 스키머',
    image: '/items-images/Muji Stainless Steel Skimmer.jpg',
    category: 'cooking utensils & tools',
    tags: ['skimmer', 'Muji'],
    link: 'https://muji.com.au/products/stainless-steel-skimmer?variant=42850879471835'
  },
  {
    id: 72,
    name: 'Muji Stainless Steel Potato Masher',
    koreanName: '무지 스테인리스 스틸 포트토마셔',
    image: '/items-images/Muji Stainless Steel Potato Masher.jpg',
    category: 'cooking utensils & tools',
    tags: ['potato masher', 'Muji'],
    link: 'https://muji.com.au/products/stainless-steel-potato-masher?variant=42240808419547'
  },
  {
    id: 73,
    name: 'Muji Heatproof Glass Measuring Cup',
    koreanName: '무지 내열성 글라스 계량컵',
    image: '/items-images/Muji Heatproof Glass Measuring Cup.jpg',
    category: 'cooking utensils & tools',
    tags: ['measuring cup', 'Muji'],
    link: 'https://muji.com.au/products/heatproof-glass-measuring-cup-mcc78a5a?srsltid=AfmBOopxnRKNShEa5-4mm9wQa5wX0R-PY4U9lhzs_zf1-Mrm_StjMEQo&variant=47575433085147'
  },
  {
    id: 74,
    name: 'Essteele Pervita Copper Base Stainless Steel Frying Pan 24cm',
    koreanName: '엘스티일 퍼비타 구리 베이스 프라이드팬 24cm',
    image: '/items-images/ESSTEELE_PERVITA_OpenSkillet24cm.jpg',
    category: 'cookware',
    tags: ['frying pan', 'Essteele'],
    link: 'https://www.essteele.com.au/products/essteele-per-vita-copper-base-stainless-steel-induction-open-french-skillet-24cm'
  },
  {
    id: 75,
    name: 'Essteele Per Vita Copper Base Stainless Steel Pot 20cm/3.4L',
    koreanName: '엘스티일 퍼비타 구리 베이스 스테인리스 스틸 팟 20cm/3.4L',
    image: '/items-images/Essteele Per Vita Copper Base Stainless Steel Pot 20cm/3.4L.jpg',
    category: 'cookware',
    tags: ['pot', 'Essteele'],
    link: 'https://www.essteele.com.au/products/essteele-per-vita-copper-base-stainless-steel-induction-covered-saucepan-20cm-3-4l'
  },
  {
    id: 76,
    name: 'Essteele Per Vita Copper Base Stainless Steel Stockpot 24cm/5.5L',
    koreanName: '엘스티일 퍼비타 구리 베이스 스테인리스 스틸 스톡포트 24cm/5.5L',
    image: '/items-images/Essteele Per Vita Copper Base Stainless Steel Stockpot 24cm/5.5L.jpg',
    category: 'cookware',
    tags: ['stockpot', 'Essteele'],
    link: 'https://www.essteele.com.au/products/essteele-per-vita-copper-base-stainless-steel-induction-5-piece-cookware-set'
  },
  {
    id: 77,
    name: 'Essteele Per Vita Copper Base Stainless Steel Saucepan 14cm/1.2L',
    koreanName: '엘스티일 퍼비타 구리 베이스 스테인리스 스틸 사우스팬 14cm/1.2L',
    image: '/items-images/Essteele Per Vita Copper Base Stainless Steel Saucepan 14cm/1.2L.jpg',
    category: 'cookware',
    tags: ['saucepan', 'Essteele'],
    link: 'https://www.essteele.com.au/products/essteele-per-vita-copper-base-stainless-steel-induction-5-piece-cookware-set?_pos=20&_sid=ce583e720&_ss=r'
  },
  {
    id: 78,
    name: 'Essteele Stainless Steel 20cm Universal Steamer',
    koreanName: '엘스티일 스테인리스 스틸 20cm 유니버설 스테이머',
    image: '/items-images/Essteele Stainless Steel 20cm Universal Steamer.jpg',
    category: 'cookware',
    tags: ['universal steamer', 'Essteele'],
    link: 'https://www.essteele.com.au/products/essteele-16-18-20cm-universal-steamer-insert?pr_prod_strat=jac&pr_rec_id=6ebc56a69&pr_rec_pid=7154813599884&pr_ref_pid=7156408483980&pr_seq=uniform'
  },
];

// Category options for kitchen/tableware items
export const categories = [
  { value: 'all', label: 'All Items', koreanLabel: '전체' },
  { value: 'appliances', label: 'Appliances', koreanLabel: '가전제품' },
  { value: 'cookware', label: 'Cookware', koreanLabel: '조리기구' },
  { value: 'cooking utensils & tools', label: 'Utensils & Tools', koreanLabel: '조리도구' },
  { value: 'tableware', label: 'Tableware', koreanLabel: '식기류' },
  { value: 'drinkware', label: 'Drinkware', koreanLabel: '음료용품' },
  { value: 'accessories', label: 'Accessories', koreanLabel: '액세서리' },
  { value: 'baking', label: 'Baking', koreanLabel: '베이킹' },
  { value: 'storage', label: 'Storage', koreanLabel: '보관용품' },
  { value: 'cleaning tools', label: 'Cleaning Tools', koreanLabel: '청소도구' }
];

// Example categories for kitchen items:
// - Cookware: pots, pans, woks, skillets, etc.
// - Tableware: plates, bowls, cups, chopsticks, etc.
// - Utensils: spatulas, ladles, tongs, knives, etc.
// - Appliances: rice cooker, blender, etc.
// - Storage: containers, jars, etc.
